import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { AuthorizationErrorComponent } from './authorization-error/authorization-error.component'

@NgModule({
  imports: [CommonModule, AuthorizationErrorComponent],
})
export class CoreModule {}
